import ImgSlot from '@/ui/ImgSlot';

import styles from './EventPoster.module.css';

interface EventPosterProps {
  code: string;
  src?: string;
  alt?: string;
}

export default function EventPoster({ code, src, alt }: EventPosterProps) {
  return (
    <figure className={styles.root} aria-label={`${code} poster`}>
      <ImgSlot src={src} alt={alt ?? code} eager />
      <span className={`${styles.cor} ${styles.tl}`} />
      <span className={`${styles.cor} ${styles.tr}`} />
      <span className={`${styles.cor} ${styles.bl}`} />
      <span className={`${styles.cor} ${styles.br}`} />
    </figure>
  );
}
